export class LFProjectRights {
  public releaseOrders = false;
  public createOrders = false;
  public processRight = false;
  public cancelOrders = false;
}
